import { PointsPlatform } from '@/types';
import {
  Network,
  NetworkIdType,
  TokenInfo,
  networks,
} from '@sonarwatch/portfolio-core';
import { RemovableRef, useLocalStorage } from '@vueuse/core';
import { defineStore } from 'pinia';
interface State {
  tokenInfos: Map<NetworkIdType, Map<string, TokenInfo>>;
  pointsPlatforms: RemovableRef<PointsPlatform[]>;

  networks: Network[];
}

export const useDataStore = defineStore('data', {
  state: (): State => ({
    tokenInfos: new Map(),
    pointsPlatforms: useLocalStorage('pinia/data/pointsPlatforms', []),
    networks: Array.from(Object.values(networks)),
  }),
  getters: {
    getNetworksSortedByAddressSystem: (state) => {
      return state.networks.sort((networkA, networkB) => {
        if (networkA.addressSystem < networkB.addressSystem) return -1;
        if (networkA.addressSystem > networkB.addressSystem) return 1;
        if (networkA.name < networkB.name) return -1;
        return 1;
      });
    },
    getTokenInfo: (state) => {
      return (
        address: string | null,
        networkId: NetworkIdType,
      ): TokenInfo | undefined =>
        address ? state.tokenInfos.get(networkId)?.get(address) : undefined;
    },

    getNetworkById: (state) => {
      return (networkId: string): Network | undefined =>
        state.networks.find((n) => n.id === networkId);
    },
  },
  actions: {
    async fetch() {},
    pushTokenInfos(
      networkId: NetworkIdType,
      newTokenInfos: Map<string, TokenInfo>,
    ) {
      const oldTokenInfos: Map<string, TokenInfo> =
        this.tokenInfos.get(networkId) || new Map();

      this.tokenInfos.set(
        networkId,
        new Map<string, TokenInfo>([...oldTokenInfos, ...newTokenInfos]),
      );
    },
  },
});
